import { exclusiveCollectionHandle } from '../../../lib/utils/domain'

type CreatePdpUrlProps = {
  productGroupHandle: string
  collectionHandle: string | null | undefined
  colorKey: string | null | undefined
  fitKey: string | null | undefined
  sizeKey: string | null | undefined
  isKit: boolean
  isExclusive: boolean | null | undefined
  genderKey: string | null | undefined
}

export const createPdpUrl = (props: CreatePdpUrlProps) => {
  const collectionPrefix =
    props.genderKey && props.isExclusive
      ? `/collections/${exclusiveCollectionHandle(props.genderKey)}`
      : props.collectionHandle
      ? `/collections/${props.collectionHandle}`
      : ''

  const baseUrl = `${collectionPrefix}/${props.isKit ? 'kits' : 'products'}/${
    props.productGroupHandle
  }`

  const searchParams = new URLSearchParams()
  if (props.colorKey) {
    searchParams.set('color', props.colorKey)
  }
  if (props.fitKey) {
    searchParams.set('fit', props.fitKey)
  }
  if (props.sizeKey) {
    searchParams.set('size', props.sizeKey)
  }

  return `${baseUrl}?${searchParams.toString()}`
}
